<template>
  <div>
    <RevenueIndex
      :endpoint="getEndpoint"
      :fstId="`riderDebits_${getId}_`"
      :qso="getEndpointOptions"
    />
  </div>
</template>

<script>
import { useEndpoints } from '@/composables'
import RevenueIndex from '@/composites/transaction/revenue/index/Index.vue'

export default {
  name: 'ViewRiderUserDebitTransactions',

  components: {
    RevenueIndex,
  },
  computed: {
    getId() {
      return this.$route.params.id
    },
    getEndpoint() {
      return useEndpoints.invoice.revenues()
    },
    getEndpointOptions() {
      return {
        append: `&user=${this.$route.params.id}`,
        prepend: `?`,
      }
    },
  },
}
</script>
